module.exports = __webpack_public_path__ + "img/logo.d1b4a5ca.png";